import { format, parseISO } from "date-fns"
import { OFFLINE_PAYMENT_METHODS } from "src/main/Billing/Payments/helpers"

// Dates arrive as marina-local ISO days ("2026-08-12"), so they are
// formatted as calendar days rather than converted from a timestamp.
export const formatDay = (isoDay) => format(parseISO(isoDay), "MMM d, yyyy")

// Marina-local wall time with no offset ("2026-08-12T10:00:00"), so it is
// formatted as written rather than converted to the viewer's timezone.
export const formatMoment = (isoLocal) =>
  format(parseISO(isoLocal), "MMM d, yyyy 'at' h:mm a")

const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1)

export const methodLabel = ({
  paymentKind,
  paymentMethodType,
  cardBrand,
  bankName,
  cardLast4,
  offlinePaymentType,
}) => {
  if (paymentMethodType === "bank_account") {
    return `${bankName} ending in ${cardLast4}`
  }
  if (paymentKind === "card") {
    // A reader payment canceled before the charge never records a card.
    if (!cardLast4) {
      return paymentMethodType === "card_present" ? "Card reader" : "Card"
    }
    return cardBrand
      ? `${capitalize(cardBrand)} ending in ${cardLast4}`
      : `Ending in ${cardLast4}`
  }

  return OFFLINE_PAYMENT_METHODS[offlinePaymentType] || offlinePaymentType
}

export const methodReference = ({ checkNumber, achConfirmation }) => {
  if (checkNumber) return `#${checkNumber}`
  return achConfirmation || null
}

export const PAYMENT_ICON = "fa-regular fa-money-bill"

export const INVOICE_ICON = "fa-regular fa-file-invoice"

export const methodWithReference = (payment) =>
  [methodLabel(payment), methodReference(payment)].filter(Boolean).join(" ")

const METHOD_TYPE_ICONS = {
  card: "fa-solid fa-credit-card",
  card_present: "fa-solid fa-credit-card",
  bank_account: "fa-solid fa-building-columns",
}

const OFFLINE_TYPE_ICONS = {
  cash: "fa-solid fa-money-bill",
  check: "fa-solid fa-money-check",
  manual_ach: "fa-solid fa-building-columns",
  external_txn: "fa-solid fa-arrow-right-arrow-left",
}

export const paymentIcon = ({ paymentMethodType, offlinePaymentType }) =>
  METHOD_TYPE_ICONS[paymentMethodType] ||
  OFFLINE_TYPE_ICONS[offlinePaymentType] ||
  "fa-solid fa-money-bill"

export const describeOfflineType = ({
  paymentType,
  checkNumber,
  achConfirmation,
}) => {
  const label = OFFLINE_PAYMENT_METHODS[paymentType] || paymentType
  if (checkNumber) return `${label} #${checkNumber}`
  if (achConfirmation) return `${label} ${achConfirmation}`
  return label
}
